<template>
  <v-container id="dashboard" fluid tag="section">
    <div class="px-10">
      <v-row>
        <div
          class="d-flex flex-column customersPinChart mb-4"
          style="width:420px"
        >
          <div id="customersPinChart" class="pt-2 pb-2">
            <apexchart
              type="pie"
              :options="customersPinChart.chartOptions"
              :series="customersPinChart.series"
            ></apexchart>
          </div>
        </div>
        <div id="labelCheckInChart">
          <apexchart
            type="bar"
            height="300"
            width="600"
            :options="labelCheckInChart.chartOptions"
            :series="labelCheckInChart.series"
          ></apexchart>
        </div>
        <div id="customerCheckInChart">
          <apexchart
            type="bar"
            height="300"
            width="480"
            :options="customerCheckInChart.chartOptions"
            :series="customerCheckInChart.series"
          ></apexchart>
        </div>
      </v-row>
      <v-row>
        <div id="housesBarChart">
          <apexchart
            type="bar"
            height="500"
            width="1020"
            :options="housesBarChart.chartOptions"
            :series="housesBarChart.series"
          ></apexchart>
        </div>
        <div id="housesBarStackChart">
          <apexchart
            type="bar"
            height="500"
            width="480"
            :options="housesBarStackChart.chartOptions"
            :series="housesBarStackChart.series"
          ></apexchart>
        </div>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { fetchDashboardData } from "@/api/dashboard";
import VueApexCharts from "vue-apexcharts";

export default {
  name: "Dashboard",
  components: {
    apexchart: VueApexCharts
  },

  data() {
    return {
      loaded: false,
      customersPinChart: {
        series: [44, 55, 13, 43, 22, 0, 0, 0, 0],
        chartOptions: {
          theme: {
            mode: "dark"
          },
          chart: {
            width: 380,
            type: "pie"
          },
          labels: ["A", "B", "C", "D", "E", "F", "G", "H", "I"],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 300
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ]
        }
      },

      colors: [],

      housesBarChart: {
        series: [{ data: [] }],
        chartOptions: {
          theme: {
            mode: "dark"
          },
          chart: {
            height: 350,
            type: "bar",
            events: {
              click: function(chart, w, e) {
                // console.log(chart, w, e)
              }
            }
          },
          colors: this.colors,
          plotOptions: {
            bar: {
              columnWidth: "85%",
              distributed: true
            }
          },
          dataLabels: {
            enabled: false,
            formatter: function(val) {
              return val;
            },
            offsetY: -20,
            style: {
              fontSize: "14px",
              colors: ["#304758"]
            }
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: this.colors,
                fontSize: "12px"
              }
            }
          }
        }
      },

      housesBarStackChart: {
        series: [
          {
            name: "已选",
            data: [0, 0, 0]
          },
          {
            name: "空闲",
            data: [0, 0, 0]
          }
        ],
        chartOptions: {
          theme: {
            mode: "dark"
          },
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10
            }
          },
          xaxis: {
            // type: 'datetime',
            categories: []
          },
          legend: {
            position: "right",
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
        }
      },

      labelCheckInChart: {
        series: [
          {
            name: "已签入",
            data: [0, 0]
          },
          {
            name: "未签入",
            data: [0, 0]
          }
        ],
        chartOptions: {
          theme: {
            mode: "dark"
          },
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10
            }
          },
          xaxis: {
            // type: 'datetime',
            categories: []
          },
          legend: {
            position: "right",
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
        }
      },

      customerCheckInChart: {
        series: [
          {
            name: "已签入",
            data: [0, 0]
          },
          {
            name: "未签入",
            data: [0, 0]
          }
        ],
        chartOptions: {
          theme: {
            mode: "dark"
          },
          chart: {
            type: "bar",
            height: 350,
            stacked: true,
            toolbar: {
              show: true
            },
            zoom: {
              enabled: true
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0
                }
              }
            }
          ],
          plotOptions: {
            bar: {
              horizontal: false,
              borderRadius: 10
            }
          },
          xaxis: {
            // type: 'datetime',
            categories: []
          },
          legend: {
            position: "right",
            offsetY: 40
          },
          fill: {
            opacity: 1
          }
        }
      },

      headers: [],
      items: [],
      basisinfo: {
        authors_count: "",
        books_count: "",
        logs_count: "",
        publishers_count: "",
        bookinstances_count: ""
      },
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false
      }
    };
  },

  computed: {},

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.getDashboard();
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },

  methods: {
    myEventHandler(e) {
     
      console.log('myEventHandler xxxx')
       this.getDashboard();
    },
    getDashboard() {
      fetchDashboardData().then(response => {
        this.customersPinChart.series =
          response.data.customers_pin_chart.series;

        this.customersPinChart.chartOptions = {
          ...this.customersPinChart.chartOptions,
          ...{ labels: response.data.customers_pin_chart.chartoptions_labels }
        };

        this.housesBarChart.series = [
          { name: "套数", data: response.data.houses_bar_chart.series_data }
        ];

        this.housesBarChart.chartOptions = {
          ...this.housesBarChart.chartOptions,
          ...{
            xaxis: {
              categories:
                response.data.houses_bar_chart.chartoptions_xaxis_categories
            }
          }
        };

        this.housesBarStackChart.series = [
          {
            name: "已选",
            data: response.data.houses_bar_stack_chart.series_data_02
          },
          {
            name: "空闲",
            data: response.data.houses_bar_stack_chart.series_data_01
          }
        ];

        this.housesBarStackChart.chartOptions = {
          ...this.housesBarStackChart.chartOptions,
          ...{
            xaxis: {
              categories:
                response.data.houses_bar_stack_chart
                  .chartoptions_xaxis_categories
            }
          }
        };

        this.labelCheckInChart.series = [
          {
            name: "已签入",
            data: response.data.labels_check_in_chart.series_data_02
          },
          {
            name: "未签入",
            data: response.data.labels_check_in_chart.series_data_01
          }
        ];

        this.labelCheckInChart.chartOptions = {
          ...this.labelCheckInChart.chartOptions,
          ...{
            xaxis: {
              categories:
                response.data.labels_check_in_chart
                  .chartoptions_xaxis_categories
            }
          }
        };
        this.customerCheckInChart.series = [
          {
            name: "已签入",
            data: response.data.customers_check_in_chart.series_data_02
          },
          {
            name: "未签入",
            data: response.data.customers_check_in_chart.series_data_01
          }
        ];

        this.customerCheckInChart.chartOptions = {
          ...this.customerCheckInChart.chartOptions,
          ...{
            xaxis: {
              categories:
                response.data.customers_check_in_chart
                  .chartoptions_xaxis_categories
            }
          }
        };
      });
      this.loaded = true;
    }
  }
};
</script>

<style>
/* #dashboard {
  background-color: rgb(228, 224, 224);
}
.apexcharts-legend-text {
  color: rgb(124, 121, 117) !important;
}
.apexcharts-text tspan  {
  color: rgb(124, 121, 117) !important;
} */
.customersPinChart {
  background-color: rgba(70, 70, 70, 0.9) !important;
}
</style>
